export default __webpack_public_path__ + "static/media/LOGO-2@2x.0b25581f.png";